import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'semantic-ui-react';
import './bankAccounts.css';
import { bankMapping } from '../../app/common/util';
import BankIcon from './components/BankIcon';
import { toastr } from 'react-redux-toastr';
export default class Account extends Component {
  static propTypes = {
    account: PropTypes.object,
  };

  handleClick = () => {
    const { account, openModal, selectAccount } = this.props;

    const { verified } = account;

    // Remove keys which are not required. TODO: optimize
    if (typeof account === 'object' && account.hasOwnProperty('status')) {
      delete account['status'];
    }

    if (typeof account === 'object' && account.hasOwnProperty('addedOn')) {
      delete account['addedOn'];
    }

    // openModal UpdateBankAccountModal
    if (!verified) {
      if (openModal && typeof openModal === 'function') {
        selectAccount(account); // set selected bank in app state (state.bank.select)
        openModal('UpdateBankAccountModal', {account});
      }
    } else {
      toastr.error('Bank Account', 'Verified account cannot be edited!');
    }
  }

  render() {
    const { account, border, clickable, customClass } = this.props;
    return (
      <div className={customClass}>
        <Card onClick={clickable ? this.handleClick : () => {}} className={border ? '' : 'noBorder'}>
          <Card.Content>
            <Card.Header>{bankMapping(account.bankName)} <span>IFSC: {account.ifsc}</span></Card.Header>
            <Card.Meta>{account.accountNumber} | {account.shortName}</Card.Meta>
            <BankIcon bank={{code:account.bankName, name: bankMapping(account.bankName)}} />
          </Card.Content>
        </Card>
      </div>
    )
  }
}
